module.exports = __webpack_public_path__ + "static/media/ele-tutor-child.299d7f91.jpg";